import React from 'react';
import {View} from 'MWComponents';
import tpl from '../templates/interactive';
import PropTypes from 'prop-types';

export default class extends View {
    template = tpl;

    constructor(props) {
        super(props);

        this.state = {
            showModal: false
        };

        return this;
    }

    componentDidMount() {
        this.unlisten = this.context.history.listen(() => {
            if (this.state.showModal) {
                this.setState({showModal: false});
                document.body.classList.remove('disable-scroll');
            }
        });
    }

    componentWillUnmount() {
        if (this.unlisten) {
            this.unlisten();
        }
        document.body.classList.remove('disable-scroll');
    }

    toggleModal = () => {
        const willOpen = !this.state.showModal;
        this.setState({showModal: willOpen});

        document.body.classList.toggle('disable-scroll', willOpen);
    };

    static displayName = 'DownloadAppBottom.Views';

    static contextTypes = {
        history: PropTypes.object
    };
}
